import { Component, Injector, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../authentication/services/authentication.service';
import { UserModel } from '../../../../authentication/models/user.model';
import { UserService } from '../../../../authentication/services/user.service';
import { Router } from '@angular/router';
import { SidebarService } from '../../../services/sidebar.service';
import { RouteService } from '../../../../routing/services/route.service';
import { MultiTenantService } from '../../../../authentication/services/multi-tenant.service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { ModalService } from '../../../../modals/services/modal.service';
import { TenantsModalComponent } from '@kaiser-software/chassis-core/src/app/layouts/components/partials/tenants-modal/tenants-modal.component';

@Component({
    selector: 'chassis-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [
        ModalService,
    ]
})
export class HeaderComponent implements OnInit {

    /**
     * Current tenant scope
     */
    public currentTenantScope;

    public impersonatedUser: UserModel;

    /**
     * The AuthenticationService instance.
     */
    public authenticationService: AuthenticationService;

    /**
     * The UserModel instance.
     *
     * @type {UserModel}
     */
    public user: UserModel;

    public sidebarService: SidebarService;

    /**
     * Angular Router
     *
     */
    private router: Router;

    /**
     * Chassis Router Service
     *
     */
    private routeService: RouteService;

    /**
     * Multi tenant service
     *
     */
    private tenantService: MultiTenantService;

    private userService: UserService;

    public tenants = [];

    public impersonationSelectParams = {
        searchJoin: 'and',
        filter: 'id;name;email',
    }

    constructor(
        protected injector: Injector,
        protected modalService: ModalService
    ) {
        this.authenticationService = this.injector.get(AuthenticationService);
        this.tenantService         = this.injector.get(MultiTenantService);
        this.userService           = this.injector.get(UserService);
        this.router                = this.injector.get(Router);
        this.routeService          = this.injector.get(RouteService);
        this.sidebarService        = this.injector.get(SidebarService);
    }

    public ngOnInit() {
        this.authenticationService.user().subscribe((user: UserModel) => {
            this.user = user;

            this.currentTenantScope = this.tenantService.getCurrentScope();
        });
    }


    public logout() {
        this.authenticationService.logout().then(() => {
            this.routeService.navigate('login');
        });
    }

    public changeTenantScope(scope: number) {
        this.tenantService.setCurrentScope(scope);
    }

    public getUsersEndpoint() {
        return this.userService.all(true);
    }

    public impersonate() {
        this.authenticationService.impersonate(this.impersonatedUser).then((user) => {
            this.changeTenantScope(user.tenant_scope);
        });
    }

    public stopImpersonating() {
        this.authenticationService.stopImpersonating().then(() => {
            this.impersonatedUser = null;
        });
    }

    public openTenantsModal() {
        const modal = this.modalService.open(TenantsModalComponent, {}, {
            classes: 'slide-up',
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/partials/header/header.component.ts